import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-image" }
const _hoisted_2 = {
  key: 0,
  class: "session-notice mb-5"
}
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = {
  key: 0,
  class: "session-notice__timer mb-0"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "" }, "Estamos actualizando el sistema...", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "mb-4" }, [
      _createElementVNode("i", { class: "fas fa-cog fa-spin" })
    ], -1)),
    (_ctx.notice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.notice), 1),
          (_ctx.countdown)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.countdown), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "logo-gtr fade-in-image pb-5",
          alt: "GTR Evolution",
          src: 
          require('@/assets/img/brand/gtr-evolution-logo-vertical-color-on-dark.svg')
        
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    })
  ]))
}